__turbopack_context__.v({
  "center-wrap": "bAmX0q_center-wrap",
  "contentsContainer": "bAmX0q_contentsContainer",
  "headerContainer": "bAmX0q_headerContainer",
  "headerWrap": "bAmX0q_headerWrap",
  "left-wrap": "bAmX0q_left-wrap",
  "right-wrap": "bAmX0q_right-wrap",
  "simpleHeader-men": "bAmX0q_simpleHeader-men",
});
